import { render } from "./TwoFactorDisableModal.vue?vue&type=template&id=7da42d8d&ts=true"
import script from "./TwoFactorDisableModal.vue?vue&type=script&lang=ts"
export * from "./TwoFactorDisableModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__